/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class LogoutIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke,
            width = 21,
            height = 20
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <g stroke={stroke} fill={fill} fillRule="evenodd">
                    <path d="M10.202 0H.798C.38 0 0 .386 0 .81v18.38c0 .424.38.81.798.81h9.404c.418 0 .798-.386.798-.81v-3.233c.006-.428-.377-.822-.798-.822-.422 0-.805.394-.799.822v2.421H1.597V1.622h7.806v2.42c-.006.429.377.823.799.823.421 0 .804-.394.798-.822V.81c-.003-.443-.419-.812-.798-.811z"/>
                    <path d="M21 10.498a.944.944 0 0 0-.216-.567l-4.25-4.675c-.288-.268-.84-.378-1.162-.069-.317.305-.307.897.008 1.203l2.989 3.283H4.797c-.44 0-.797.37-.797.825 0 .456.357.826.797.826h13.572l-2.989 3.283c-.272.282-.322.895-.008 1.203.314.308.885.21 1.162-.069l4.25-4.675a.813.813 0 0 0 .216-.568z"/>
                </g>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Logout.tsx